module.exports = {"placeholder":"vyhledávací pole","searchAutocompleteTitle":"Historie vyhledávání:"}